import { Button as MuiButton, ButtonTypeMap, ExtendButtonBase } from '@mui/material';

import { Spinner } from 'src/components/spinner';
import { ReactComponent as ArrowRight } from 'src/assets/svg/arrow-right-hos.svg';
import { getTheme } from 'src/utils/getTheme';
import { Themes } from 'src/shared/enum/Themes';

import { ButtonProps } from './types';
import { styles } from './styles';

const { themeName } = getTheme();
const hosTheme = themeName === Themes.HOUSE_OF_SOCIAL;

export const Button: ExtendButtonBase<ButtonTypeMap<ButtonProps>> = ({
    design = 'primary',
    disabled,
    loading,
    bordered,
    startIcon,
    endIcon,
    children,
    className,
    variant,
    noEndIcon,
    ...restProps
}: ButtonProps) => {
    const isText = variant === 'text';
    return (
        <MuiButton
            disabled={disabled || loading}
            css={{
                ...styles.container(bordered, disabled, isText),
                ...(design === 'light' && styles.light(bordered, isText)),
                ...(design === 'primary' && styles.primary(bordered)),
                ...(design === 'success' && styles.success),
            }}
            className={className}
            {...restProps}
            endIcon={!noEndIcon && hosTheme ? <ArrowRight /> : null}
        >
            {loading ? (
                <Spinner css={styles.spinner} />
            ) : (
                <div css={styles.content}>
                    {startIcon}
                    {children}
                    {endIcon}
                </div>
            )}
        </MuiButton>
    );
};
